import { shiftPlanningService } from 'hq/services';
import { useQuery } from 'react-query';
import { ShiftPlanningPartnerUnitsData } from 'hq/services/shift-planning-service.types';
import { useFeatureFlagContext } from 'shared/contexts/feature-flag-provider';
import { QUERY_KEYS } from 'api/query-keys';

const useGetShiftPlanningPartnersData = () => {
  const { allowPartners } = useFeatureFlagContext();
  return useQuery<ShiftPlanningPartnerUnitsData | null, Error>({
    queryKey: QUERY_KEYS.partnersFilter(),
    queryFn: async () => {
      if (allowPartners) {
        return await shiftPlanningService.getShiftPlanningPartnersData();
      }
      return null;
    },
  });
};

export { useGetShiftPlanningPartnersData };
